<div class="progress-container" *ngFor="let p of results.items">
  <div class="label">
    <span>{{p.title}}</span>
    <span class="bold">{{p.label}}</span>
  </div>
  <ion-progress-bar
    [value]="p.value"
    [ngClass]="{'green': p.status === 'positive', 'red': p.status === 'negative'}"
  ></ion-progress-bar>

  <div class="details-container" *ngIf="p.options && p.options.length > 0">
    <div class="progress-container" *ngFor="let o of p.options">
      <div class="label">
        <div class="options">
          <div class="option stars"
               [ngClass]="{'selected': parseInt(o.title) > 0 && parseInt(value) <= parseInt(o.title)}"
               *ngFor="let value of results.range let j = index">
          </div>
        </div>
        <span class="bold">{{o.label}}</span>
      </div>
      <ion-progress-bar
        [value]="o.value"
        [ngClass]="{'green': o.status === 'positive', 'red': o.status === 'negative'}"
      ></ion-progress-bar>
    </div>
  </div>
</div>
